
export const AddIcon = ({color="#4E4B66", size=24}: {color?: string, size?: number}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.2334 12.0332L19.7667 12.0332" stroke={color} strokeLinecap="round"/>
      <path d="M12 4.2666L12 19.7999" stroke={color} strokeLinecap="round"/>
    </svg> 
  );
}